export const paymentAction = {
  SAVECOUNTRYLIST: "SAVECOUNTRYLIST",
  SAVERESERVATIONDETAIL: "SAVERESERVATIONDETAIL",
  SAVERAWREQUEST :"SAVERAWREQUEST"
};
